import React from 'react';
import {
  Card,
  Input,
  Radio,
  Select,
  Text,
  StepsRegisterImport,
} from 'v3/components';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { fetchCities, fetchProvinces } from 'utils/fetches';
import { CIVIL_STATUS, CPF_MASK, PIS_MASK, } from 'v3/utils/masks';
const GeneralData = ({
  data,
  setData,
  disableFields,
  frontImageCnh,
  errors,
  loading,
  genders
}) => {

  return (
    <Card
      header={
        <Text color="#464E5F" type="header">
          Dados pessoais
        </Text>
      }
      HeaderRightComponent={
        <Col>
          <StepsRegisterImport
            stepText="Importação da CNH"
            activeStep={frontImageCnh?.length}
            variant="light"
          />
        </Col>
      }
    >
      <Row className="form">
        <Col xs={12} lg={6} md={6}>
          <Input
            label="Nome *"
            value={data?.name}
            onChange={event => setData({ ...data, name: event.target.value })}
            disabled={disableFields || loading}
            error={errors?.['generalData.name']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Input
            type="date"
            label="Data de nascimento *"
            value={data?.dateOfBirth}
            onChange={event => setData({ ...data, dateOfBirth: event.target.value })}
            disabled={disableFields || loading}
            error={errors?.['generalData.dateOfBirth']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Input
            label={'CPF *'}
            value={data?.cpf}
            onChange={event => setData({ ...data, cpf: event.target.value })}
            disabled={disableFields || loading}
            masked={true}
            mask={CPF_MASK}
            error={errors?.['generalData.cpf']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Input
            label="RG *"
            value={data?.rgNumber}
            disabled={disableFields || loading}
            onChange={event => setData({ ...data, rgNumber: event.target.value })}
            error={errors?.['generalData.rgNumber']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Input
            type="date"
            label="Data de emissão RG"
            value={data?.rgDispatchDate}
            onChange={event => setData({ ...data, rgDispatchDate: event.target.value })}
            disabled={loading}
            error={errors?.['generalData.rgDispatchDate']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Input
            label="Órgão emissor RG *"
            value={data?.rgOrganEmission}
            onChange={event => setData({ ...data, rgOrganEmission: event.target.value })}
            disabled={disableFields || loading}
            error={errors?.['generalData.rgOrganEmission']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Select.Async
            label="UF emissor RG *"
            onSearch={fetchProvinces}
            value={data?.rgOrganEmissionUf}
            onChange={value => setData({ ...data, rgOrganEmissionUf: value })}
            isDisabled={disableFields || loading}
            getOptionLabel={option => `${option.name}`}
            getOptionValue={option => option.id}
            error={errors?.['generalData.rgOrganEmissionUf']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Select.Async
            label="Cidade natal *"
            onSearch={fetchCities}
            value={data?.cityOfBirth}
            onChange={value => setData({ ...data, cityOfBirth: value })}
            getOptionLabel={option =>
              `${option.name}, ${option?.province?.uf || '--'}`
            }
            getOptionValue={option => option.id}
            error={errors?.['generalData.cityOfBirth']}
            isDisabled={disableFields || loading}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Input
            label="Mãe *"
            value={data?.motherName}
            disabled={disableFields || loading}
            onChange={event => setData({ ...data, motherName: event.target.value })}
            error={errors?.['generalData.motherName']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Input
            label="Pai *"
            value={data?.fatherName}
            disabled={disableFields || loading}
            onChange={event => setData({ ...data, fatherName: event.target.value })}
            error={errors?.['generalData.fatherName']}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Select
            label="Estado Civil *"
            value={data?.civilStatus}
            onChange={value => setData({ ...data, civilStatus: value })}
            options={CIVIL_STATUS}
            error={errors?.['generalData.civilStatus']}
            isDisabled={loading}
          />
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Select
            label="Sexo *"
            value={data?.gender}
            onChange={value => setData({ ...data, gender: value })}
            options={genders}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            error={errors?.['generalData.gender']}
            isDisabled={loading}
          />
        </Col>

        <Col lg={4} md={4} xs={12} className="mb-3">
          <Radio.Group
            label="Autônomo *"
            onChange={({ target }) => setData({ ...data, isAutonomous: target.value })}
            value={data?.isAutonomous}
            horizontal
            disabled={loading}
          >
            <Radio value>
              <Text color="dark" type="label">
                Sim
              </Text>
            </Radio>
            <Radio value={false}>
              <Text color="dark" type="label">
                Não
              </Text>
            </Radio>
          </Radio.Group>
        </Col>

        <Col lg={6} md={6} xs={12}>
          <Input
            value={data?.pis}
            onChange={e => setData({ ...data, pis: e.target.value })}
            label={data?.isAutonomous ? 'PIS *' : 'PIS'}
            masked
            mask={PIS_MASK}
            error={errors?.['generalData.pis']}
            disabled={loading}
          />
        </Col>
      </Row>
    </Card>
  )
}

export default GeneralData;
